import Vue from 'vue';
import Router from 'vue-router';
import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';
import ROUTE_NAME = RouterStore.ROUTE_NAME;
import ROUTE_PATH = RouterStore.ROUTE_PATH;

import Page404 from '@/views/Page404.vue';
import MainPage from '@/views/MainPage.vue';
import PathOverview from "@/views/PathOverview.vue";
import ThemePath from "@/views/ThemePath.vue";
import DefaultPage from "@/views/DefaultPage.vue";
import DetailPage from "@/views/DetailPage.vue";
import IconsPage from "@/views/IconsPage.vue";
import RhizomePage from "@/views/RhizomePage.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_URL,
  routes: [
    {
      path: '*',
      redirect: ROUTE_PATH.PAGE_404,
    },
    {
      path: ROUTE_PATH.PAGE_404,
      name: ROUTE_NAME.PAGE_404,
      component: Page404,
    },
    {
      path: ROUTE_PATH.MAIN_PAGE,
      name: ROUTE_NAME.MAIN_PAGE,
      component: MainPage,
    },
    {
      path: ROUTE_PATH.PATH_OVERVIEW_PAGE,
      name: ROUTE_NAME.PATH_OVERVIEW_PAGE,
      component: PathOverview,
    },
    {
      path: ROUTE_PATH.PATH_PAGE + '/:id',
      name: ROUTE_NAME.PATH_PAGE,
      component: ThemePath
    },
    {
      path: ROUTE_PATH.ABOUT,
      name: ROUTE_NAME.ABOUT,
      component: DefaultPage,
    },
    {
      path: ROUTE_PATH.DATA_PROTECTION,
      name: ROUTE_NAME.DATA_PROTECTION,
      component: DefaultPage
    },
    {
      path: ROUTE_PATH.IMPRINT,
      name: ROUTE_NAME.IMPRINT,
      component: DefaultPage
    },
    {
      path: ROUTE_PATH.ICONS,
      name: ROUTE_NAME.ICONS,
      component: IconsPage,
    },
    {
      path: ROUTE_PATH.DETAIL_PAGE + '/:id',
      name: ROUTE_NAME.DETAIL_PAGE,
      component: DetailPage,
    },
    {
      path: ROUTE_PATH.RHIZOME_PAGE,
      name: ROUTE_NAME.RHIZOME_PAGE,
      component: RhizomePage,
    },
  ],
});
